import {
  EMPTY_ARRAY_LENGTH,
  PAGINATION_INDEXING,
  LIST_PAGE_SIZE,
  emptyString,
} from "../../../../constants";

/** Initial pagination/search query for infinite-scroll list screens. */
export const createListDefaultQuery = (pageSize = LIST_PAGE_SIZE) => ({
  search: emptyString,
  from: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  take: pageSize,
});

/** Reset search text and return to the first page (functional setState updater). */
export const resetListSearchQuery = (
  prevQuery,
  pageSize = LIST_PAGE_SIZE
) => ({
  ...prevQuery,
  search: emptyString,
  from: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  take: pageSize,
});

/** Apply a new search value and reset pagination (functional setState updater). */
export const applyListSearchQuery = (
  prevQuery,
  search,
  pageSize = LIST_PAGE_SIZE
) => ({
  ...prevQuery,
  search,
  from: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  take: pageSize,
});

/** Advance infinite-scroll `from` based on items already loaded. */
export const advanceListPaginationQuery = (prevQuery, from) => ({
  ...prevQuery,
  from,
});

/** Reset `from` to the first page while keeping other query fields. */
export const resetListPaginationFrom = (query) => ({
  ...query,
  from: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
});

/** Whether infinite scroll has another page based on page-size chunks. */
export const hasMoreListItems = (itemCount, pageSize = LIST_PAGE_SIZE) =>
  itemCount > EMPTY_ARRAY_LENGTH &&
  itemCount % pageSize === EMPTY_ARRAY_LENGTH;
